import { Component, OnInit } from '@angular/core';
import { QuoteService } from '../quote.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Configuration } from '../configurator/configuration';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-generate-doc',
  standalone: false,
  templateUrl: './generate-doc.component.html',
  styleUrl: './generate-doc.component.css'
})
export class GenerateDocComponent implements OnInit {

    loaded = false;
    generated = true;
    editingCover = false;
    needEmail = false;
    coverSettings: CoverSettings = {
        userEmail: '',
        title: '',
        preparedFor: '',
        preparedBy: '',
        phone: '',
        email: '',
        vertical: '',
        allVerticals: []
    };
    userEmail = '';
    allVerticals: string[] = [];
    
    constructor( public quoteService: QuoteService, 
                 private http: HttpClient,
                 private router: Router ) {
        
    }
    
    ngOnInit(): void {
        
        this.http.get<CoverSettings>( `api/generate/settings`)
            .subscribe( s => {
                this.coverSettings = s;
                this.loaded = true;
                
                this.allVerticals = this.coverSettings.allVerticals;
                
                if ( s.userEmail ) {
                    this.userEmail = s.userEmail;
                    this.needEmail = false;
                } else {
                    //this.needEmail = true;
                }
                
            } );
        
    }
    
    //getPDFSrc(): SafeUrl {
    //    return this.domSanitizer.bypassSecurityTrustUrl( `api/` )
    //}
    
    generatePDF(): void {
        
        //this.generated = false;
        
        //setTimeout( () => {
        //    this.generated = true;
        //} );
        
        window.open( 'api/generate/Quote', '_blank' );
        
    }
    
    exportXlsx(): void {
        window.open( 'api/generate/export', '_blank' )
    }
    
    edit( configuration: Configuration ): void {
        
        this.router.navigate( ['configure', configuration.id ] );
        
    }
    
    deleteConfiguration( configuration: Configuration ): void {
        this.quoteService.deleteConfiguration( configuration )
          .subscribe();
    }
    
    editCover() {
        this.editingCover = true;
    }
    
    closeEditCover() {
        this.editingCover = false;
        //this.generatePDF();
    }
    
    editCoverField( field: string ) {
        
        this.http.post( `api/generate/cover-field/${field}`, this.coverSettings[ field ] )
        .subscribe();
        
    }
    
    back(): void {
        this.router.navigateByUrl( '' );
    }
        
    submitEmail(): void {
        
    }
    
}

interface CoverSettings {

    [key: string]: string|string[];
    
    userEmail: string;
    title: string;
    preparedFor: string;
    preparedBy: string;
    phone: string;
    email: string;
    vertical: string;
    allVerticals: string[];
}
